module.exports = __webpack_public_path__ + "media/icons/box55-87ebbea2.png";